export const View = () => {
  return <div className="dot--separator">·</div>;
};
